import * as React from "react";
import pageIds from "~/pageIds";
import type { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import { CommonLibraryCertificateOverview } from "../../CommonComponents/CommonLibraryCertificateViews";
export const LibraryCertificatesNewRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.library.certificates.create,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonLibraryCertificateOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => null,
};
